import { IAddedActivity } from '../AddActivityViewSwitch/IAddActivity'
import { IPostActivity } from '../types/IPostActivity'

export const createActivitySubmitArray = (
  addedActivities: IAddedActivity[],
): IPostActivity[] =>
  addedActivities.map(addedActivity => ({
    activityUuid: addedActivity.activity.activityUuid,
    isLocked: addedActivity.isLocked,
    personUuids: addedActivity.personUuids,
  }))
